import { usesMockAPI } from './backend-adapters'
import { ApiError, api, UnknownOutcomeError } from './client'

export type EngagementKind = 'favorite' | 'subscription'

export async function writeEngagement(kind: EngagementKind, id: string, active: boolean) {
  const path = kind === 'favorite' ? '/api/favorites' : '/api/subscriptions'
  const key = kind === 'favorite' ? 'videoId' : 'actressId'
  const result = await api<Record<string, unknown>>(
    path,
    active ? { method: 'POST', body: { [key]: id } } : { method: 'DELETE', query: { [key]: id } },
  )
  if (usesMockAPI) return
  if (typeof result.meta?.[active ? 'created' : 'deleted'] !== 'boolean') throw new UnknownOutcomeError()
  if (active && (!result.data || result.data[key] !== id || typeof result.data.id !== 'string')) {
    throw new UnknownOutcomeError()
  }
  // Both created/deleted false are successful idempotent receipts, not a failed operation.
}
export async function readEngagement(kind: EngagementKind, id: string): Promise<boolean> {
  const { data } = await api<{ active: unknown }>('/api/library/engagement', { query: { kind, id } })
  if (typeof data?.active !== 'boolean') throw new ApiError(502, 'BAD_RESPONSE', '服务响应不符合接口合同')
  return data.active
}
